import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  pagingCustomerSourceGroup,
  getCustomerSourceGroupById,
  saveCustomerSourceGroup,
  deleteCustomerSourceGroup,
  importCustomerSourceExcel,
  syncCustomerSourceGroup,
} from "app/services/CustomerSourceGroupService";
import { CustomerSourceGroup } from "app/common/Model/CustomerSourceGroup";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { downloadTemplateCustomerSourceGroup } from "app/services/ImportExcelService";

export default class CustomerSourceGroupStore {
  listAllCustomerSourceGroup = [];
  searchCustomerSourceGroup = new SearchObject();
  pageCustomerSourceGroup = null;
  selectedCustomerSourceGroup = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteCustomerSourceGroup = false;
  openImportExcel = false;
  constructor() {
    makeAutoObservable(this);
  }

  pagingCustomerSourceGroup = () => {
    pagingCustomerSourceGroup(this.searchCustomerSourceGroup)
      .then(({ data }) => {
        this.pageCustomerSourceGroup = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  hanleSyncCustomerSourceGroup = () => {
    syncCustomerSourceGroup()
      .then(({ data }) => {
        toast.success("Đồng bộ thành công");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đồng bộ dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchCustomerSourceGroup) => {
    this.searchCustomerSourceGroup = checkSearchObject(
      this.searchCustomerSourceGroup,
      searchCustomerSourceGroup
    );
    this.pagingCustomerSourceGroup();
  };

  handleOpenFormCreateOrEdit = (customerSourceGroupId) => {
    if (Boolean(customerSourceGroupId)) {
      getCustomerSourceGroupById(customerSourceGroupId)
        .then(({ data }) => {
          this.selectedCustomerSourceGroup = data;
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedCustomerSourceGroup = new CustomerSourceGroup();
      this.openFormCreateOrEdit = true;
    }
  };

  saveCustomerSourceGroup = (customerSourceGroup) => {
    return saveCustomerSourceGroup(customerSourceGroup)
      .then(() => {
        this.selectedCustomerSourceGroup = null;
        toast.success("Lưu bản ghi thành công!");
        this.handleClosePopup();
        this.pagingCustomerSourceGroup();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin nhóm nguồn khách hàng có lỗi");
      });
  };

  handleDeleteCustomerSourceGroup = (customerSourceGroup) => {
    this.selectedCustomerSourceGroup = { id: customerSourceGroup?.id };
    this.openConfirmDeleteCustomerSourceGroup = true;
  };

  handleOpenImportExcel = () => {
    this.openImportExcel = true;
  };
  handleCloseImportExcel = () => {
    this.openImportExcel = false;
  };

  saveImportExcelCustomer = (file) => {
    importCustomerSourceExcel(file)
      .then(() => {
        toast.success("Nhập excel thành công");
        this.searchCustomerSourceGroup = {
          ...this.searchCustomerSourceGroup,
          pageIndex: 1,
        };
        this.openImportExcel = false;
        this.pagingCustomerSourceGroup();
      })
      .catch(() => {
        toast.error("Nhập excel thất bại");
      })
      .finally(() => {
        this.handleClosePopup();
      });
  };

  handleConfirmDeleteCustomerSourceGroup = () =>
    deleteCustomerSourceGroup(this?.selectedCustomerSourceGroup?.id)
      .then(() => {
        if (
          this.searchCustomerSourceGroup.pageIndex > 1 &&
          this.pageCustomerSourceGroup.content.length === 1
        ) {
          this.searchCustomerSourceGroup.pageIndex -= 1;
        }
        toast.success("Xóa nhóm nguồn khách hàng thành công!");
        this.handleClosePopup();
        this.pagingCustomerSourceGroup();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa nhóm nguồn khách hàng có lỗi");
      });

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteCustomerSourceGroup = false;
    this.openImportExcel = false;
  };

  handleDownloadExcelTemplate = async () => {
    try {
      const response = await downloadTemplateCustomerSourceGroup();

      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "NHOM_KHACH.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  resetStore = () => {
    this.searchCustomerSourceGroup = new SearchObject();
    this.pageCustomerSourceGroup = null;
    this.selectedCustomerSourceGroup = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteCustomerSourceGroup = false;
  };
}
